import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withSnackbar} from "notistack";
import {isMobile, isMobileOnly, isTablet} from "react-device-detect";
import {startLoadingAnimate, stopLoadingAnimate} from "services/ducks/loading";
import {Col, Row} from "react-bootstrap";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import {
  Button,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@material-ui/core";
import {faSave} from "@fortawesome/free-regular-svg-icons";
import {faArrowLeft, faBan, faCalculator, faCheck, faPrint} from "@fortawesome/free-solid-svg-icons"
import {ContainerTitle, FullSizedButton} from "../styles";
import {SessionTitle, BannerBloqueioOperacaoEmprestimo} from './styles'
import NumberFormat from "react-number-format";
import api from "services/structure/api";
import moment from 'moment';
import {DatePicker} from "components";
import {ItemsSubtitle} from "../Simulador/styles";
import MensagemErro from "components/MensagemErro";
import MensagemSucesso from "components/MensagemSucesso";

class Emprestimos extends Component {

  state = {
    parametros: {
      valorEmprestimo: '',
      prazoMeses: '',
    },    
    dataLiberacaoCredito: '',
    isSimularButtonDisabled: true,
    isContratarButtonDisabled: true,
    datasLimiteCredito: [],
    openDadosSimulacaoEmprestimo: true,
    openResultadoSimulacaoEmprestimo: false,
    openQuitarEmprestimo: false,
    openAmortizarEmprestimo: false,
    emprestimoQuitacao: null,
    valorLimiteEmprestimo: 0,
    dtDeposito: new Date(),
    dadosAmortizacao: null,
    valorEmprestimo: '',
    prazoMeses: '',
    taxaJuros: '',
    valorParcela: '',
    dataInicioContrato: '',
    valorIOF: '',
    valorJuros: '',
    valorLiquido: '',
    codigoBanco: '',
    agencia: '',
    banco: '',
    conta: '',
    dvConta: '',
    bancos: [],
    valorEmprestimoAposSimular: '',
    prazoMesesAposSimular: '',
    dataLiberacaoCreditoAposSimular: '',
    mostrarMensagemSucesso: false,
    emprestimoSolicitadoExpandido: false,
    bloquearConcessao: false,
    bloquearQuitacao: false,
    bloquearAmortizacao: false,
    mensagemBloqueioOperacaoEmprestimo: '',
    }

  componentDidMount() {
    window.scrollTo(0, 0)
    const promises = []
    this.props.startLoadingAnimate()

    const contratosPromises = this.contratosVigentes()
    const exibirDadosSimulacaoEmprestimo = this.exibirDadosSimulacaoEmprestimo()
    const simulacaoEmprestimo = this.prepararDadosEmprestimo()

    promises.push(simulacaoEmprestimo)
    promises.push(contratosPromises)
    promises.push(exibirDadosSimulacaoEmprestimo)

    Promise.all(promises)
      .then(values => {
        const newState = Object.assign(...values)
        const bloquearConcessao = Boolean(newState.bloquearConcessao);
        const permitePorPendencia = newState.openDadosSimulacaoEmprestimoPendente !== false;
        newState.openDadosSimulacaoEmprestimo = !bloquearConcessao
          && permitePorPendencia
          && newState.openDadosSimulacaoEmprestimo !== false;
        delete newState.openDadosSimulacaoEmprestimoPendente;
        this.setState(newState)
      })
      .catch(e => {
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! "
        this.props.enqueueSnackbar(mensagem, { variant: "error" })
      })
      .finally(() => this.props.stopLoadingAnimate())
  }

  async contratosVigentes() {
    try {
      const response = await api.get("/emprestimo/contratos-vigentes")
      const historicoAlteracoes = response.data
      return { historicoAlteracoes: historicoAlteracoes }
    } catch (err) {
      return console.error(err)
    }
  }
  
  async exibirDadosSimulacaoEmprestimo() {
    try {
      const response = await api.get("/emprestimo/existe-contratos-pendentes-aprovacao");
      const dados = response.data;

      return {
        dados,
        erros: dados.existeContratosPendentesAprovacao ? response.data.mensagem : null,
        openDadosSimulacaoEmprestimoPendente: !dados.existeContratosPendentesAprovacao,
      };
    } catch (err) {
      console.error(err);
      return {
        exibirDadosSimulacaoEmprestimo: false,
        openDadosSimulacaoEmprestimoPendente: false,
      };
    }
  }

  async prepararDadosEmprestimo() {
    try {
      const response = await api.get("/emprestimo/dados-simulacao-emprestimo")
      const simulacao = response.data
        
      if (!simulacao.sucesso) {
        this.props.enqueueSnackbar(simulacao.mensagem, { variant: 'error' });
        return {
          bloquearConcessao: Boolean(simulacao.bloquearConcessao),
          bloquearQuitacao: Boolean(simulacao.bloquearQuitacao),
          bloquearAmortizacao: Boolean(simulacao.bloquearAmortizacao),
          mensagemBloqueioOperacaoEmprestimo: simulacao.mensagemBloqueioOperacaoEmprestimo || '',
          openDadosSimulacaoEmprestimo: !simulacao.bloquearConcessao,
        }
      }

      const datasLimiteCredito = simulacao.listaDiasVencimento?.map(item => {
        const dataUTC = new Date(item.dataLiberacaoCredito);
        const dia = String(dataUTC.getUTCDate()).padStart(2, "0");
        const mes = String(dataUTC.getUTCMonth() + 1).padStart(2, "0"); // Mês começa em 0
        const ano = dataUTC.getUTCFullYear();
        const dataFormatada = `${ano}-${mes}-${dia}`; // Formato YYYY-MM-DD
        console.log('dataFormatada: ', dataFormatada);
        return dataFormatada;
      }) || []

      const toNumber = (value) => {
        if (value == null) {
          return 0;
        }
        if (typeof value === "number") {
          return Number.isFinite(value) ? value : 0;
        }
        if (typeof value === "string") {
          const normalized = value.replace(/\./g, "").replace(",", ".");
          const n = Number(normalized);
          return Number.isFinite(n) ? n : 0;
        }
        return 0;
      };

      const valorLimiteEmprestimoCalculado = Math.max(
        toNumber(simulacao.valorLimiteEmprestimo)
      );

      return {
        valorLimiteEmprestimo: valorLimiteEmprestimoCalculado,
        datasLimiteCredito,
        dataLimiteCredito: datasLimiteCredito.length > 0 ? datasLimiteCredito[0] : '',
        bloquearConcessao: Boolean(simulacao.bloquearConcessao),
        bloquearQuitacao: Boolean(simulacao.bloquearQuitacao),
        bloquearAmortizacao: Boolean(simulacao.bloquearAmortizacao),
        mensagemBloqueioOperacaoEmprestimo: simulacao.mensagemBloqueioOperacaoEmprestimo || '',
        openDadosSimulacaoEmprestimo: !simulacao.bloquearConcessao,
      }
    } catch (err) {
      console.error(err)
      this.setState({ openDadosSimulacaoEmprestimo: true })
      return {}
    }
  }

  extrairMensagemErroEmprestimo = (data) => {
    if (!data) {
      return null;
    }
    return data.avisoEmp || data.mensagem || null;
  }

  exibirErroOperacaoEmprestimo = (data, fallback) => {
    const mensagem = this.extrairMensagemErroEmprestimo(data) || fallback;
    if (mensagem) {
      this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      return true;
    }
    return false;
  }

  renderBannerBloqueioOperacaoEmprestimo = () => {
    const mensagem = this.state.mensagemBloqueioOperacaoEmprestimo;
    if (!mensagem) {
      return null;
    }
    return (
      <BannerBloqueioOperacaoEmprestimo>
        <span dangerouslySetInnerHTML={{ __html: mensagem }} />
      </BannerBloqueioOperacaoEmprestimo>
    );
  }

  isQuitacaoOperacaoIndisponivel = (element) => {
    return Boolean(element?.estaEmQuitacaoOuAmortizacaoAtiva || this.state.bloquearQuitacao);
  }

  isAmortizacaoOperacaoIndisponivel = (element) => {
    return Boolean(element?.estaEmQuitacaoOuAmortizacaoAtiva || this.state.bloquearAmortizacao);
  }

  contratarEmprestimo = () => {
    if (this.state.bloquearConcessao) {
      this.exibirErroOperacaoEmprestimo(
        { mensagem: this.state.mensagemBloqueioOperacaoEmprestimo },
        'Operação de contratação indisponível no momento.'
      );
      return;
    }
    const payload = {
      agencia: this.state.agencia,
      banco: this.state.banco,
      codigoBanco: this.state.codigoBanco,
      conta: this.state.conta,
      dvConta: this.state.dvConta,
      valorEmprestimo: this.state.valorEmprestimoAposSimular,
      prazoMeses: this.state.prazoMesesAposSimular,
      dataLiberacaoCredito: this.state.dataLiberacaoCreditoAposSimular,
    };
  
    this.props.startLoadingAnimate();
    api.post("/emprestimo/contratar-emprestimo", payload)
      .then(response => {
        const resultado = response.data;
        if (resultado?.sucesso === false || resultado?.avisoEmp) {
          const mensagem = this.extrairMensagemErroEmprestimo(resultado)
            || 'Não foi possível contratar o empréstimo.';
          this.props.enqueueSnackbar(mensagem, { variant: 'error' });
          return;
        }

        this.props.enqueueSnackbar("Empréstimo contratado com sucesso!", { variant: 'success' });

        this.setState({
          mostrarMensagemSucesso: true,
          openDadosSimulacaoEmprestimo: false,
          openResultadoSimulacaoEmprestimo: false,
          bloquearEmprestimoSemTermoEntrega: Boolean(response.data.bloquearEmprestimoSemTermoEntrega)
        });
      })
      .catch((e) => {
        let mensagem = "Não foi possível contratar o empréstimo. Tente novamente!";
        if (e?.response?.data?.mensagem) {
          mensagem = e.response.data.mensagem;
        }
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.error(e);
      })
      .finally(() => {
        this.props.stopLoadingAnimate();
      });
  };

  simularEmprestimo = () => {
    if (this.state.bloquearConcessao) {
      this.exibirErroOperacaoEmprestimo(
        { mensagem: this.state.mensagemBloqueioOperacaoEmprestimo },
        'Operação de simulação indisponível no momento.'
      );
      return;
    }

    const payload = {
      valorEmprestimo: this.state.parametros.valorEmprestimo,
      prazoMeses: this.state.parametros.prazoMeses,
      dataLiberacaoCredito: this.state.dataLiberacaoCredito,
    };


    this.props.startLoadingAnimate();
    api.post("/emprestimo/simular-emprestimo", payload)
      .then(response => {
        const simulacao = response.data;

        if (!simulacao.sucesso || simulacao.avisoEmp) {
          const mensagem = this.extrairMensagemErroEmprestimo(simulacao)
            || 'Não foi possível simular o empréstimo.';
          this.setState({
            erros: mensagem,
            openResultadoSimulacaoEmprestimo: false
          });
          this.props.enqueueSnackbar(mensagem, { variant: 'error' });
          return;
        }

        this.setState({
          valorEmprestimo: simulacao.valorEmprestimo,
          prazoMeses: simulacao.prazoMeses,
          taxaJuros: simulacao.taxaJuros,
          valorParcela: simulacao.valorParcela,
          dataInicioContrato: simulacao.dataInicioContrato,
          valorIOF: simulacao.valorIOF,
          valorJuros: simulacao.valorJuros,
          valorLiquido: simulacao.valorLiquido,
          bancos: simulacao.bancos,
          valorEmprestimoAposSimular: simulacao.valorEmprestimo,
          prazoMesesAposSimular: simulacao.prazoMeses,
          dataLiberacaoCreditoAposSimular: simulacao.dataLiberacaoCredito,
          bloquearEmprestimoSemTermoEntrega: Boolean(simulacao.bloquearEmprestimoSemTermoEntrega),
          erros: null,
        });

        this.setState({ openResultadoSimulacaoEmprestimo: true })
      })
      .catch((e) => {
        let mensagem = "Não foi possível conectar-se ao servidor. Tente novamente! ";
        if(e?.response?.data?.mensagem) {
          mensagem = e.response.data.mensagem;
        }
        this.setState({
          erros: mensagem,
          openResultadoSimulacaoEmprestimo: false
        });
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      })
      .finally(() => {
        this.props.stopLoadingAnimate()
      });
  }

  clearEditData = () => {
    this.setState({ 
        openQuitarEmprestimo: false,
        openDadosSimulacaoEmprestimo: true,
        openAmortizarEmprestimo: false,
        emprestimoQuitacao: null, 
        dadosAmortizacao: null,
        bloquearEmprestimoSemTermoEntrega: false,
    });
  }

  openSimularQuitacaoEmprestimo(emprestimo) {
    this.setState({
      openAmortizarEmprestimo: false,
      dadosAmortizacao: null,
      openDadosSimulacaoEmprestimo: false,
      openResultadoSimulacaoEmprestimo: false,
    });
    if (this.isQuitacaoOperacaoIndisponivel(emprestimo)) {
      return;
    }
    this.simularQuitarEmprestimo(emprestimo, new Date())
  }

  async simularQuitarEmprestimo(emprestimo, dtPagamento) {
    this.props.startLoadingAnimate()
    return api.get(`/emprestimo/dados-simulacao-quitacao?idContratoEmprestimo=${emprestimo.idContratoEmprestimo}&dtPagamento=${dtPagamento}`)
      .then(response => {
        console.log('dados-simulacao-quitacao', response)
        const dados = response.data;
        const inadimplente = this.state.bloquearContratacaoPorInadimplencia;
        if (!inadimplente && this.exibirErroOperacaoEmprestimo(dados, null)) {
          this.setState({
            openAmortizarEmprestimo: false,
            dadosAmortizacao: null,
            openDadosSimulacaoEmprestimo: false,
            openResultadoSimulacaoEmprestimo: false,
          });
          return;
        }
        this.setState({
          emprestimoQuitacao: emprestimo,
          openQuitarEmprestimo: true,
          openDadosSimulacaoEmprestimo: false,
          openResultadoSimulacaoEmprestimo: false,
          openAmortizarEmprestimo: false,
          dadosAmortizacao: null,
          dtPagamento: dtPagamento,
          dadosQuitacao: dados
        });
      })
      .catch(e => {
        console.log(e)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! "
        this.props.enqueueSnackbar(mensagem, { variant: "error" })
      })
      .finally(() => this.props.stopLoadingAnimate())
  }

  async efetivarQuitarEmprestimo() {
    if (this.state.bloquearContratacaoPorInadimplencia) {
      this.exibirErroOperacaoEmprestimo(
        { mensagem: this.state.avisoInadimplencia },
        'Atenção: Identificamos mais de uma parcela em aberto em um dos contratos vigentes. Não é possível continuar com a operação até a regularização do contrato.'
      );
      return;
    }
    this.props.startLoadingAnimate();
    try {
      const response = await api.get(`/emprestimo/efetivar-quitacao?idContratoEmprestimo=${this.state.emprestimoQuitacao.idContratoEmprestimo}&dtPagamento=${this.state.dtPagamento}`)
      const quitacao = response.data;
      if (this.exibirErroOperacaoEmprestimo(quitacao, null)) {
        return;
      }
      const buscaNova = await this.contratosVigentes();
      console.log('dadosQuitacao', quitacao)
      this.setState({
        dadosQuitacao: quitacao,
        historicoAlteracoes: buscaNova.historicoAlteracoes
      });
    } catch (err) {
      console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
    } finally {
      this.props.stopLoadingAnimate();
    }
  }

  openSimularAmortizarEmprestimo(emprestimo) {
    if (this.isAmortizacaoOperacaoIndisponivel(emprestimo)) {
      return;
    }
    this.setState({
        openAmortizarEmprestimo: true,
        emprestimoAmortizacao: emprestimo,
        openQuitarEmprestimo: false,
        openDadosSimulacaoEmprestimo: false,
        openResultadoSimulacaoEmprestimo: false,
        qtdParcelasAmortizar: null
    })
  }

  async simularAmortizarEmprestimo() {
    this.props.startLoadingAnimate();
    try {
      const dtDeposito = this.state.dtDeposito.toISOString().split('T')[0]
      const response = await api.get(`/emprestimo/dados-simulacao-amortizacao?idContratoEmprestimo=${this.state.emprestimoAmortizacao.idContratoEmprestimo}&dtDeposito=${dtDeposito}&qtdParcelasAmortizacao=${this.state.qtdParcelasAmortizar}`)
      const simulacao = response.data;
      console.log(simulacao);
      if (this.exibirErroOperacaoEmprestimo(simulacao, null)) {
        return;
      }
      this.setState({
        dadosAmortizacao: simulacao
      });
    } catch (err) {
      console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
    } finally {
      this.props.stopLoadingAnimate();
    }
  }

  async efetivarAmortizarEmprestimo() {
    if (this.state.bloquearContratacaoPorInadimplencia) {
      this.exibirErroOperacaoEmprestimo(
        { mensagem: this.state.avisoInadimplencia },
        'Não é possível amortizar enquanto houver parcelas em atraso.'
      );
      return;
    }
    this.props.startLoadingAnimate();
    try {
      const dtDeposito = this.state.dtDeposito.toISOString().split('T')[0]
      const response = await api.get(`/emprestimo/efetivar-amortizacao?idContratoEmprestimo=${this.state.emprestimoAmortizacao.idContratoEmprestimo}&dtDeposito=${dtDeposito}&qtdParcelasAmortizacao=${this.state.qtdParcelasAmortizar}`)
      const amortizacao = response.data;
      if (this.exibirErroOperacaoEmprestimo(amortizacao, null)) {
        return;
      }
      const buscaNova = await this.contratosVigentes();
      this.setState({
        dadosAmortizacao: amortizacao,
        historicoAlteracoes: buscaNova.historicoAlteracoes
      });
    } catch (err) {
      console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
    } finally {
      this.props.stopLoadingAnimate();
    }
  }

  imprimirArquivo(element, servico, nomeArquivo) {
    this.props.startLoadingAnimate();
    return api.get(`documentos/${servico}?idContratoEmprestimo=${element.idContratoEmprestimo}`, { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${nomeArquivo}-${element.idContratoEmprestimo}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.props.stopLoadingAnimate();
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        this.props.stopLoadingAnimate();
      }
      );
  }

  aberturaCredito() {
    this.props.startLoadingAnimate();
    return api.get(`documentos/abertura-credito`, { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Termo-Abertura-Credito.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.props.stopLoadingAnimate();
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        this.props.stopLoadingAnimate();
      }
    );
  }

  imprimirComprovante(tipoOperacao, dtDeposito, valorOperacao, idContrato) {
    this.props.startLoadingAnimate();
    return api.get(`documentos/comprovante-operacao-ap?dtDeposito=${dtDeposito}&tipoOperacao=${tipoOperacao}&valorOperacao=${valorOperacao}&idContrato=${idContrato}`, { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Comprovante-${tipoOperacao}-${idContrato}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.props.stopLoadingAnimate();
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        this.props.stopLoadingAnimate();
      }
      );
  }


  renderDadosSimulacaoDoEmprestimo = () => {
    if (this.state.bloquearConcessao) {
      return null;
    }

    return (
      <div className="">
        {this.state.erros && <MensagemErro mensagem={this.state.erros} />}
        <SessionTitle>Dados para simulação do Empréstimo</SessionTitle>
        <Row>
          <Col sm={6} >
            <input
              type="hidden"
              name="valorEmprestimoHidden"
              value={this.state.valorEmprestimoAposSimular || ""}
            />
            <input
              type="hidden"
              name="prazoMesesHidden"
              value={this.state.prazoMesesAposSimular || ""}
            />
            <input
              type="hidden"
              name="dataLiberacaoCreditoHidden"
              value={this.state.dataLiberacaoCreditoAposSimular || ""}
            />
            {!this.state?.info?.contribuicaoValorAbsoluto &&
              <div className="input-text-percent">
                <NumberFormat
                  value={this.state.valorLimiteEmprestimo}
                  thousandSeparator="."
                  decimalSeparator=","
                  customInput={TextField}
                  onValueChange={(e) => this.setStateOnValueChange('valorEmprestimo', e.floatValue)}
                  variant="outlined"
                  decimalScale={2}
                  fixedDecimalScale={2}
                  label="Limite do Empréstimo"
                  name="limiteEmprestimo"
                  prefix={"R$ "}
                  fullWidth
                  className="MuiFormControl-marginNormal"
                  disabled={true}
                />
              </div>
            }
          </Col>
          <Col sm={6} >
            <div className="input-valor-emprestimo">
              <NumberFormat
                value={this.state.info?.valorEmprestimo}
                thousandSeparator="."
                decimalSeparator=","
                customInput={TextField}
                variant="outlined"
                decimalScale={2}
                fixedDecimalScale={2}
                onValueChange={(e) => this.setStateOnValueChange('valorEmprestimo', e.floatValue)}
                label="Valor R$"
                name="limiteEmprestimo"
                prefix={"R$ "}
                fullWidth
                className="MuiFormControl-marginNormal"
                inputProps={{ maxLength: 13}}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={6} >
            <div className="input-text-absolute">
              <NumberFormat
                value={this.state.info?.prazoMeses}
                defaultValue="0"
                thousandSeparator="."
                decimalSeparator=","
                customInput={TextField}
                onValueChange={(e) => this.setStateOnValueChange('prazoMeses', e.floatValue)}
                variant="outlined"
                decimalScale={0}
                fixedDecimalScale={0}
                inputProps={{ maxLength: 2}}
                label="Prazo (meses): "
                name="prazoMeses"
                fullWidth
                className="MuiFormControl-marginNormal"
              />
            </div>
          </Col>
          <Col sm={6} >
            <div className="input-text-percent">
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                disabled={this.state.disabled}
                label="Data de Liberação do Crédito"
                name="dataLiberacaoCredito"
                value={this.state.dataLiberacaoCredito || ''}
                onChange={(e) => this.setStateOnValueChange('dataLiberacaoCredito', e.target.value)}
                select={true}>
                {this.state.datasLimiteCredito?.map((data, index) => (
                  <MenuItem key={index} value={data}>
                    {moment(data).format("DD/MM/YYYY")} {/* Formate a data se necessário */}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          </Col>
        </Row>
        <Row>
          {!isTablet && <Col sm={3}></Col>}
          <Col sm={3}>
            <FullSizedButton
              key="btnSimularEmprestimo"
              type="submit"
              variant="contained"
              onClick={this.simularEmprestimo}
              disabled={this.state.isSimularButtonDisabled}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className="alterar-contribuicao-salvar-icon" />
              <span className="alterar-contribuicao-salvar-label">Simular</span>
            </FullSizedButton>
          </Col>
        </Row>
      </div>
    )
  }

  renderSimulacaoDoEmprestimo = () => {
      return <div className="resultado-simulacao-emprestimo">
        <Row>
          <Col sm={6}>
            <NumberFormat
              value={this.state.valorEmprestimo || ""}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={"R$ "}
              label="Valor Empréstimo (R$)"
              name="valorEmprestimo"
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
              />
          </Col>

          <Col sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Prazo (meses)"
              value={this.state.prazoMeses || ""}
              disabled={true}
              name="prazoMeses"
            />
          </Col>

          <Col sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Taxa de Juros (%)"
              value={parseFloat(this.state.taxaJuros || 0).toFixed(2)}
              disabled={true}
              name="taxaJuros"
            />
          </Col>

          <Col sm={6}>
            <NumberFormat
              value={this.state.valorParcela || ""}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={"R$ "}
              label="Valor Parcela (R$)"
              name="valorParcela"
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>

          <Col sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Data Início do Contrato"
              value={this.state.dataInicioContrato || ""}
              disabled={true}
              name="dataInicioContrato"
            />
          </Col>

          <Col sm={6}>
            <NumberFormat
              value={this.state.valorIOF || ""}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={"R$ "}
              label="Valor IOF (R$)"
              name="valorIOF"
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>
          
          <Col sm={6}>
            <NumberFormat
              value={this.state.valorJuros || ""}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={"R$ "}
              label="Valor Juros (R$)"
              name="valorJuros"
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>

          <Col sm={6}>
            <NumberFormat
              value={this.state.valorLiquido || ""}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              prefix={"R$ "}
              label="Valor Líquido (R$)"
              name="valorLiquido"
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>
        </Row>

        {this.state.bloquearEmprestimoSemTermoEntrega === false && !this.state.bloquearContratacaoPorInadimplencia && (
          <Row>
            <Col sm={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Código Banco"
                value={this.state.codigoBanco || ""}
                onChange={(e) => {
                  const codigoBanco = e.target.value;
                  this.setStateOnValueChange({ codigoBanco });
                  this.setState({ codigoBanco });
            
                  const bancoSelecionado = this.state.bancos.find(banco => banco.codigoBanco === codigoBanco);
            
                  if (bancoSelecionado) {
                    this.setStateOnValueChange({ banco: bancoSelecionado.nome });
                    this.setState({ banco: bancoSelecionado.nome });
                  } else {
                    this.setStateOnValueChange({ banco: "" });
                    this.setState({ banco: "" });
                  }
                }}
                name="codigoBanco"
                inputProps={{ maxLength: 5,pattern: "^[\\-0-9]{0,5}$"  }}
              />
            </Col>

            <Col sm={6}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              select 
              label="Banco"
              value={this.state.banco || ""}
              onChange={(e) =>{
                const bancoSelecionado = this.state.bancos.find(banco => banco.nome === e.target.value);
                if (bancoSelecionado) {
                  this.setStateOnValueChange({
                    banco: bancoSelecionado.nome,
                    codigoBanco: bancoSelecionado.codigoBanco,
                  });
                  
                  this.setState({
                    banco: bancoSelecionado.nome,
                    codigoBanco: bancoSelecionado.codigoBanco,
                  });
                }
                }
              } 
              name="banco"
            >
              {this.state.bancos.map((banco) => (
                <MenuItem key={banco.bancoId} value={banco.nome}>
                  {banco.nome} ({banco.codigoBanco})
                </MenuItem>
              ))}
            </TextField>
            </Col>

            <Col sm={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Agência"
                value={this.state.agencia || ""}
                onChange={(e) =>{
                  const valor = e.target.value.replace(/\D/g, ""); 
                  this.setStateOnValueChange({ agencia: valor })
                  this.setState({ agencia: valor })
                }}
                onBlur={() => {
                  const agencia = document.querySelector('[name="agencia"]').value;
                  this.setStateOnValueChange('agencia', agencia);
                }}
                
                name="agencia"
                inputProps={{ maxLength: 4,inputMode: "numeric", pattern: "[0-9]*" }}
              />
            </Col>

            <Col sm={4}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Conta"
                value={this.state.conta || ""}
                onChange={(e) => 
                {
                  const valor = e.target.value.replace(/\D/g, ""); 
                  this.setStateOnValueChange({ conta: valor })
                  this.setState({ conta: valor })}
                }
                onBlur={() => {
                  const conta = document.querySelector('[name="conta"]').value;
                  this.setStateOnValueChange('conta', conta);
                }}
                name="conta"
                inputProps={{ maxLength: 11, inputMode: "numeric", pattern: "[0-9]*" }} 

              />
            </Col>

            <Col sm={2}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="DV"
                value={this.state.dvConta || ""}
                onChange={(e) => {
                  const valor = e.target.value.replace(/\D/g, ""); 
                  this.setStateOnValueChange({ dvConta: valor })
                  this.setState({ dvConta: valor })}
                }
                onBlur={() => {
                  const dvConta = document.querySelector('[name="dvConta"]').value;
                  this.setStateOnValueChange('dvConta', dvConta);
                }}
                inputProps={{ maxLength: 1, inputMode: "numeric", pattern: "[0-9]*" }} 
                name="dvConta"
              />
            </Col>
          </Row>
        )}
        <Row>
            {!isTablet && <Col sm={3}></Col>}
            <Col sm={3}>
              {this.state.bloquearEmprestimoSemTermoEntrega === false ? (
                <FullSizedButton
                  type="button"
                  variant="contained"
                  onClick={this.contratarEmprestimo}
                  disabled={this.state.isContratarButtonDisabled}>
                  <FontAwesome.FontAwesomeIcon icon={faSave} className="alterar-contribuicao-salvar-icon" />
                  <span className="alterar-contribuicao-salvar-label">Contratar</span>
                </FullSizedButton>
              ) : (
                <FullSizedButton
                  type="button"
                  variant="contained"
                  onClick={() => this.setState({ emprestimoSolicitadoExpandido: !this.state.emprestimoSolicitadoExpandido })}>
                  <span className="alterar-contribuicao-salvar-label">Clique aqui</span>
                </FullSizedButton>
              )}
            </Col>
          </Row>
          {this.state.bloquearEmprestimoSemTermoEntrega !== false && this.state.emprestimoSolicitadoExpandido && (
            <Row>
              <Col>
                {this.renderEmprestimoSolicitado()}
              </Col>
            </Row>
          )}
      </div>
    
  }


  renderGridHistoricoDesktop = () => {
    return <TableContainer>
      <Table>
        <TableHead>
          <TableRow key="header-row">
            <TableCell>Nº do Contrato</TableCell>
            <TableCell>Data do Início do Contrato</TableCell>
            <TableCell>Valor (R$)</TableCell>
            <TableCell>Prazo (meses)</TableCell>
            <TableCell>Parcela (R$)</TableCell>
            <TableCell>Situação</TableCell>
            <TableCell>Contrato</TableCell>
            <TableCell>Resumo</TableCell>
            <TableCell>Histórico do Contrato</TableCell>
            <TableCell>Quitação</TableCell>
            <TableCell>Amortização</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.historicoAlteracoes.data.map(this.renderGridHistoricoSingleRowDesktop)}
        </TableBody>
      </Table>
    </TableContainer>
  }

  renderGridHistoricoSingleRowDesktop = (element) => {
    return <TableRow key={element.idContratoEmprestimo}>
      <TableCell>{element.idContratoEmprestimo}</TableCell>
      <TableCell>{moment(element.dtInicioContrato).format("DD/MM/YYYY")}</TableCell>
      <TableCell>
            <NumberFormat
              value={element.valorEmprestimo}
              displayType={"text"}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={2}
            /></TableCell>
      <TableCell>{element.numeroParcelas}</TableCell>
      <TableCell>
            <NumberFormat
              value={element.valorParcela}
              displayType={"text"}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={2}
            /></TableCell>
      <TableCell>{element.situacaoEmprestimo}</TableCell>
      <TableCell>
        <Button variant="contained"
           onClick={() => this.imprimirArquivo(element, 'contrato-emprestimo', 'Contrato-Emprestimo')}>
          <FontAwesome.FontAwesomeIcon icon={faPrint} />
        </Button>
      </TableCell>
      <TableCell>
        <Button variant="contained"
           onClick={() => this.imprimirArquivo(element, 'contrato-emprestimo-resumo', 'Contrato-Emprestimo-Resumo')}>
          <FontAwesome.FontAwesomeIcon icon={faPrint} />
        </Button></TableCell>
      <TableCell>
        <Button variant="contained"
          onClick={() => this.imprimirArquivo(element, 'contrato-emprestimo-historico', 'Contrato-Emprestimo-Historico')}>
          <FontAwesome.FontAwesomeIcon icon={faPrint} />
        </Button>
      </TableCell>
      <TableCell>
        <Button variant="contained"
          disabled={this.isQuitacaoOperacaoIndisponivel(element)}
          onClick={() => this.openSimularQuitacaoEmprestimo(element)}>
          <FontAwesome.FontAwesomeIcon icon={this.isQuitacaoOperacaoIndisponivel(element) ? faBan : faCheck}  />
        </Button>
      </TableCell>
      <TableCell>
        <Button type="submit"
          variant="contained"
          disabled={this.isAmortizacaoOperacaoIndisponivel(element)}
          onClick={() => this.openSimularAmortizarEmprestimo(element)}>
          <FontAwesome.FontAwesomeIcon icon={this.isAmortizacaoOperacaoIndisponivel(element) ? faBan : faCheck}  />
        </Button>
      </TableCell>
    </TableRow>
  }

  renderQuitarEmprestimo = () => {
    const inadimplente = this.state.bloquearContratacaoPorInadimplencia;
    const mensagemAtraso = this.state.avisoInadimplencia
      || 'Atenção: Identificamos mais de uma parcela em aberto em um dos contratos vigentes. Não é possível continuar com a operação até a regularização do contrato.';
    if(this.state.dadosQuitacao.avisoEmp && !inadimplente) {
      return <MensagemErro mensagem={this.state.dadosQuitacao.avisoEmp} />;
    } else if(this.state.dadosQuitacao.primeiraParcelaNaoPaga) {
      return <MensagemErro mensagem="Operação não permitida. A primeira parcela do contrato não foi paga." />;
    } else if (this.state.dadosQuitacao.idContratoEmprestimoQuitacao != null) {
      return this.renderImprimirSolicitacaoQuitacao();
    } else {
      return <div>
        {inadimplente && <MensagemErro mensagem={mensagemAtraso} />}
        <SessionTitle>Quitação do Contrato nº {this.state.emprestimoQuitacao?.idContratoEmprestimo}</SessionTitle>
        <Row>
          <Col sm={6}>
            <NumberFormat
              value={this.state.emprestimoQuitacao?.saldoDevedorAtual}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              label="Saldo Devedor"
              name="saldoDevedor"
              prefix={"R$ "}
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>
          <Col sm={6}>
            <DatePicker
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Data de Quitação"
                value={this.state.dtPagamento}
                onChange={ (e) => this.setStateOnValueChange('dtPagamento', e) }
                name="dtPagamento"/>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NumberFormat
              value={this.state.dadosQuitacao?.valorJuros}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              label="Juros a Pagar"
              name="valorJuros"
              prefix={"R$ "}
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>
          <Col sm={6}>
            <NumberFormat
              value={this.state.dadosQuitacao?.valorTotalQuitacao}
              thousandSeparator="."
              decimalSeparator=","
              customInput={TextField}
              variant="outlined"
              decimalScale={2}
              fixedDecimalScale={2}
              label="Valor para Quitar"
              name="valorTotalQuitacao"
              prefix={"R$ "}
              fullWidth
              className="MuiFormControl-marginNormal"
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <FullSizedButton type="submit" autoFocus className="beneficiarios-incluir" variant="contained"
                onClick={() => {this.simularQuitarEmprestimo(this.state.emprestimoQuitacao, this.state.dtPagamento)}}>
                <FontAwesome.FontAwesomeIcon icon={faCalculator} className="beneficiarios-incluir-icon"/> 
                <span className="beneficiarios-incluir-label">SIMULAR</span>
            </FullSizedButton> 
          </Col>
          {!inadimplente && (
          <Col sm={3}>
            <FullSizedButton type="submit" autoFocus className="beneficiarios-incluir" variant="contained"
                onClick={() => {this.efetivarQuitarEmprestimo()}}>
                <FontAwesome.FontAwesomeIcon icon={faSave} className="beneficiarios-incluir-icon"/> 
                <span className="beneficiarios-incluir-label">QUITAR</span>
            </FullSizedButton> 
          </Col>
          )}
          <Col sm={3}>
            <FullSizedButton type="submit" autoFocus className="voltar-button" variant="contained"
                onClick={this.clearEditData}>
                <FontAwesome.FontAwesomeIcon icon={faArrowLeft} className="voltar-button"/> 
                <span className="voltar-label">VOLTAR</span>
            </FullSizedButton>
          </Col>
        </Row>
      </div>
    }
  }

  renderImprimirSolicitacaoQuitacao() {
    const idContrato = this.state.dadosQuitacao.idContratoEmprestimoQuitacao;
    const dtPagamento = this.formatDate(this.state.dadosQuitacao.dtPagamento);
    const valorOperacao = this.state.dadosQuitacao.valorTotalQuitacao.toFixed(2);
    return (
    <div>
      <Row>
        <Col>
          <SessionTitle>Quitação solicitada com sucesso!</SessionTitle>
          <p>
            Você solicitou a quitação do empréstimo correspondente ao contrato nº {idContrato}, no dia {dtPagamento}, no valor de {<NumberFormat
                    value={valorOperacao}
                    displayType={"text"}
                    decimalSeparator={","}
                    decimalPrecision={2}
                    thousandSeparator={"."}
                    isNumericString={true}
                    prefix={"R$ "}
                    />}.
          </p>
          <p>
            A transferência deverá ser realizada exclusivamente a partir de uma conta bancária de sua titularidade, vinculada ao seu CPF.
          </p>
          <p>
            Para completar a operação, efetue uma transferência bancária ou um PIX em favor do Plano Básico da Previcel, conforme dados a seguir:
          </p>
          <p>
            Plano Básico
          </p>
          <p>
            CNPJ: 48.306.932/0001-93
          </p>
          <p>
            PIX (chave CNPJ): 48306932000193
          </p>
          <p>
            Transferência bancária
          </p>
          <p>
            Banco: Itaú Unibanco (341)
          </p>
          <p>
            Agência: 2316
          </p>
          <p>
            Conta Corrente: 01647-2
          </p>
          <p>
            Caso o depósito não se concretize, seja feito por terceiros ou em desacordo com as informações apresentadas acima, a operação não será considerada válida e o contrato<br/>
            continuará vigente. Nesse caso, os valores transferidos serão devolvidos ao pagador após desconto do custo da transação a ser efetuada pela Previcel.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <FullSizedButton autoFocus variant="contained"
                              onClick={() => {this.imprimirComprovante("QUITACAO", dtPagamento, valorOperacao, idContrato)}}>
                  <FontAwesome.FontAwesomeIcon icon={faPrint} className="beneficiarios-incluir-icon"/>
                  <span className="beneficiarios-incluir-label">IMPRIMIR ESSA MENSAGEM</span>
              </FullSizedButton>
        </Col>
      </Row>
    </div>
    );
  };

  setStateOnValueChange = (key, value) => {
    const parametros = { ...this.state.parametros, [key]: value };

    const dataLiberacaoCredito = key === 'dataLiberacaoCredito' ? value : this.state.dataLiberacaoCredito;

    // Verifica se os campos para o botão "Simular" estão preenchidos
    const isSimularButtonDisabled = !(
      parametros.valorEmprestimo &&
      parametros.prazoMeses &&
      dataLiberacaoCredito
    );

    // Verifica se os campos para o botão "Contratar" estão preenchidos
    const codigoBanco = key === 'codigoBanco' ? value : this.state.codigoBanco;
    const banco = key === 'banco' ? value : this.state.banco;
    const agencia = key === 'agencia' ? value : this.state.agencia;
    const conta = key === 'conta' ? value : this.state.conta;
    const dvConta = key === 'dvConta' ? value : this.state.dvConta;

    const camposPreenchidos = codigoBanco && banco && agencia && conta && dvConta;
    const isContratarButtonDisabled = !camposPreenchidos || this.state.bloquearEmprestimoSemTermoEntrega === true;

    this.setState({
      parametros,
      dataLiberacaoCredito,
      isSimularButtonDisabled,
      isContratarButtonDisabled,
      [key]: value, // Atualiza o campo alterado no estado
    });
  };

  renderAmortizarEmprestimo = () => {
    const inadimplente = this.state.bloquearContratacaoPorInadimplencia;
    const mensagemAtraso = this.state.avisoInadimplencia
      || 'Atenção: Identificamos mais de uma parcela em aberto em um dos contratos vigentes. Não é possível continuar com a operação até a regularização do contrato.';
    return <div>
      {inadimplente && <MensagemErro mensagem={mensagemAtraso} />}
      <SessionTitle>Amortização do contrato nº {this.state.emprestimoAmortizacao?.idContratoEmprestimo}</SessionTitle>
      <Row>
        <Col sm={6}>
          <DatePicker
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Data do Depósito"
              value={this.state.dtDeposito}
              onChange={(date) => this.setStateOnValueChange('dtDeposito', date) }
              name="dtDeposito"/>
        </Col>
        <Col sm={6}>
          <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                required
                value={this.state.qtdParcelasAmortizar}
                label="Quantidade de Parcelas a Amortizar"
                onChange={ (e) => this.setStateOnValueChange('qtdParcelasAmortizar', e.target.value) }
                name="qtdParcelasAmortizar"/>
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <FullSizedButton type="submit" autoFocus className="beneficiarios-incluir" variant="contained"
                           onClick={() => {this.simularAmortizarEmprestimo()}}>
              <FontAwesome.FontAwesomeIcon icon={faCalculator} className="beneficiarios-incluir-icon"/>
              <span className="beneficiarios-incluir-label">SIMULAR</span>
          </FullSizedButton>
        </Col>
        <Col sm={3}>
            <FullSizedButton type="submit" autoFocus className="voltar-button" variant="contained"
                            onClick={this.clearEditData}>
                <FontAwesome.FontAwesomeIcon icon={faArrowLeft} className="voltar-button"/>
                <span className="voltar-label">VOLTAR</span>
            </FullSizedButton>
        </Col>
      </Row>
    </div>
  }

  renderRetornoSimulacaoAmortizarEmprestimo = () => {
    const inadimplente = this.state.bloquearContratacaoPorInadimplencia;
    if(this.state.dadosAmortizacao.avisoEmp && !inadimplente) {
      return <MensagemErro mensagem={this.state.dadosAmortizacao.avisoEmp} />;
    } else if(this.state.dadosAmortizacao.primeiraParcelaNaoPaga) {
      return <MensagemErro mensagem="Operação não permitida. A primeira parcela do contrato não foi paga." />;
    } else if (this.state.dadosAmortizacao.sucesso) {
      return this.renderImprimirSolicitacaoAmortizacao();
    } else {
      return (
        <div>
          <SessionTitle>Dados da Amortização</SessionTitle>
          <Row>
              <Col sm={6}>
                <ItemsSubtitle>Data do Depósito</ItemsSubtitle>
                <span>
                {this.formatDate(this.state.dadosAmortizacao.dtDepositoExibicao)}
                </span>
              </Col>
              <Col sm={6}>
                <ItemsSubtitle>Quantidade de Parcelas Amortizadas</ItemsSubtitle>
                <span>
                  {this.state.dadosAmortizacao.quantidadeParcelasAmortizar}
                </span>
              </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ItemsSubtitle>Saldo Devedor Anterior</ItemsSubtitle>
              <span>
                  <NumberFormat
                      value={this.state.dadosAmortizacao.saldoDevedorAtual.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalPrecision={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                      />
              </span>
            </Col>
            <Col sm={6}>
              <ItemsSubtitle>Novo Saldo Devedor R$:</ItemsSubtitle>
              <span>
                  <NumberFormat
                      value={this.state.dadosAmortizacao.novoSaldoDevedorAtual.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalPrecision={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                      />
              </span>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ItemsSubtitle>Prazo Restante Anterior (meses):</ItemsSubtitle>
              <span>
                {this.state.dadosAmortizacao.prazoRestanteAnterior}
              </span>
            </Col>
            <Col sm={6}>
              <ItemsSubtitle>Novo Prazo (meses):</ItemsSubtitle>
              <span>
                {this.state.dadosAmortizacao.novoPrazo}
              </span>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ItemsSubtitle>Valor Total a Pagar R$:</ItemsSubtitle>
              <span>
                  <NumberFormat
                      value={this.state.dadosAmortizacao.valorTotalAmortizacao.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalPrecision={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                      />
              </span>
            </Col>
          </Row>
          {!this.state.bloquearContratacaoPorInadimplencia && (
          <Row>
            <Col sm={3}>
              <FullSizedButton type="submit" autoFocus className="beneficiarios-incluir" variant="contained"
                              onClick={() => {this.efetivarAmortizarEmprestimo()}}>
                  <FontAwesome.FontAwesomeIcon icon={faCheck} className="beneficiarios-incluir-icon"/> 
                  <span className="beneficiarios-incluir-label">AMORTIZAR</span>
              </FullSizedButton> 
            </Col>
          </Row>
          )}      
      </div>
      );
    }
  }

  formatDate(dataRecebida) {
    const data = new Date(dataRecebida)
    return `${String(data.getDate()).padStart(2, '0')}/${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;
  }

  renderImprimirSolicitacaoAmortizacao() {
    const idContrato = this.state.dadosAmortizacao.idContratoEmprestimoAmortizacao;
    const dtDeposito = this.formatDate(this.state.dadosAmortizacao.dtDeposito);
    const valorOperacao = this.state.dadosAmortizacao.valorTotalAmortizacao.toFixed(2);
    return (
    <div>
      <Row>
        <Col>
          <div>
            <div>
            <h2>Amortização solicitada com sucesso!</h2>
            <p>
              Você solicitou a amortização do empréstimo correspondente ao contrato nº {idContrato}, no dia {dtDeposito}, no valor de {<NumberFormat
                      value={valorOperacao}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalPrecision={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                      />}.
            </p>
            <p>
              A transferência deverá ser realizada exclusivamente a partir de uma conta bancária de sua titularidade, vinculada ao seu CPF.
            </p>
            <p>
              Para completar a operação, efetue uma transferência bancária ou um PIX em favor do Plano Básico da Previcel, conforme dados a seguir:
            </p>
            <p>
              Plano Básico
            </p>
            <p>
              CNPJ: 48.306.932/0001-93
            </p>
            <p>
              PIX (chave CNPJ): 48306932000193
            </p>
            <p>
              Transferência bancária
            </p>
            <p>
              Banco: Itaú Unibanco (341)
            </p>
            <p>
              Agência: 2316
            </p>
            <p>
              Conta Corrente: 01647-2
            </p>
            <p>
              Caso o depósito não se concretize, seja feito por terceiros ou em desacordo com as informações apresentadas acima, a operação não será considerada válida e o contrato<br/>
              continuará vigente. Nesse caso, os valores transferidos serão devolvidos ao pagador após desconto do custo da transação a ser efetuada pela Previcel.
            </p>
          </div>
         </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <FullSizedButton autoFocus variant="contained"
                              onClick={() => {this.imprimirComprovante("AMORTIZACAO", dtDeposito, valorOperacao, idContrato)}}>
                  <FontAwesome.FontAwesomeIcon icon={faPrint} className="beneficiarios-incluir-icon"/>
                  <span className="beneficiarios-incluir-label">IMPRIMIR ESSA MENSAGEM</span>
              </FullSizedButton>
        </Col>
      </Row>
    </div>
    );
  };

  renderEmprestimoSolicitadoCondicional() {
    if (!this.state.bloquearEmprestimoSemTermoEntrega) {
      return <MensagemSucesso mensagem="Empréstimo contratado com sucesso! Você receberá um e-mail confirmando a sua solicitação." />
    }
    return this.renderEmprestimoSolicitado();
  }

  renderEmprestimoSolicitado() {
    return (
      <div>
        <Row>
          <Col>
            <SessionTitle>TERMO DE ADESÃO AO CONTRATO DE ABERTURA DE CRÉDITO</SessionTitle>
            Prezado participante,
            <br />
            <br />
            A partir de agora, o processo de simulação e a contratação de empréstimos serão
            totalmente digitais. Para realizar a solicitação do seu crédito junto à Previcel é
            necessário assinar o termo de adesão ao contrato de abertura de crédito.
            <br />
            <br />
            O preenchimento deste termo será solicitado apenas na primeira vez em que você
            utilizar a funcionalidade. Confira como fazer:
            <br />
            <br />
            <b>
              1. Faça o download do Termo de Adesão (abaixo). Você deverá assinar o
              documento utilizando uma das seguintes alternativas:
            </b>
            <br />
            <ul>
              <li>Através de assinatura digital legalmente reconhecida;</li>
              <li>Presencialmente;</li>
              <li>Com reconhecimento de firma em cartório por autenticidade/verdadeira.</li>
            </ul>
            <br />
            <b>2. Após a assinatura você deverá realizar a entrega do Termo de Adesão:</b>
            <br />
            <ul>
              <li>Se você assinou digitalmente, envie o documento para o e-mail previcel@previcel.org.br;</li>
              <li>Se a assinatura for realizada com reconhecimento de firma em cartório por autenticidade/verdadeira, você deverá enviar o documento via correio;</li>
              <li>Caso queira assinar presencialmente, basta comparecer à sede da Previcel. Não se esqueça de trazer um documento oficial com foto.</li>
            </ul>			
            <b>3. Pronto! Assim que a Previcel confirmar o recebimento do Termo de Adesão, você poderá prosseguir com a solicitação de empréstimo.
            </b>			
            <br />
            <br />
            Dúvidas? Entre em contato com a gente!
          </Col>
        </Row>
        <Row>
          <Col>
            <FullSizedButton autoFocus variant="contained"
                                onClick={() => {this.aberturaCredito()}}>
                    <FontAwesome.FontAwesomeIcon icon={faPrint} className="beneficiarios-incluir-icon"/>
                    <span className="beneficiarios-incluir-label">IMPRIMIR ESSA MENSAGEM</span>
                </FullSizedButton>
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    return (
      <div className="meu-plano-emprestimos">

        {isTablet && <ContainerTitle>EMPRÉSTIMOS</ContainerTitle>}
        {!isMobile && <ContainerTitle>EMPRÉSTIMOS</ContainerTitle>}
        {isMobileOnly && <ContainerTitle>EMPRÉSTIMOS</ContainerTitle>}

        {this.state.historicoAlteracoes?.data?.length > 0 && (
          <div className="historico-alteracao-contribuicoes">
            <div className="">
              <h4>Contratos Vigentes</h4>
            </div>
            {!isMobile && this.renderGridHistoricoDesktop()}
          </div>
        )}

        {this.renderBannerBloqueioOperacaoEmprestimo()}

        {this.state.mostrarMensagemSucesso && this.renderEmprestimoSolicitadoCondicional()}

        {this.state.openDadosSimulacaoEmprestimo && !this.state.mostrarMensagemSucesso && !this.state.openAmortizarEmprestimo && !this.state.openQuitarEmprestimo && this.renderDadosSimulacaoDoEmprestimo()}

        {this.state.openResultadoSimulacaoEmprestimo && !this.state.mostrarMensagemSucesso && !this.state.bloquearConcessao && !this.state.openAmortizarEmprestimo && !this.state.openQuitarEmprestimo && this.renderSimulacaoDoEmprestimo()}

        {this.state.openQuitarEmprestimo && this.renderQuitarEmprestimo()}

        {this.state.openAmortizarEmprestimo && !this.state.openQuitarEmprestimo && this.renderAmortizarEmprestimo()}

        {this.state.dadosAmortizacao != null && !this.state.openQuitarEmprestimo && this.renderRetornoSimulacaoAmortizarEmprestimo()}

      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  authData: store.authState,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    startLoadingAnimate,
    stopLoadingAnimate
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(Emprestimos)));
